import { render } from "./BookedView.vue?vue&type=template&id=25cbded3"
import script from "./BookedView.vue?vue&type=script&lang=js"
export * from "./BookedView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__